var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderShowersDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.87 113.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5b952;}.cls-2{fill:#e5f1fb;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill:none;stroke-miterlimit:10;}.cls-3{stroke:#231f20;stroke-width:2.5px;}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke:#000;}.cls-4{stroke-width:3px;}.cls-5,.cls-7{stroke-width:4px;}.cls-6,.cls-8{stroke-width:5px;}.cls-7,.cls-8{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "thunder-showers-day Asset 151colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.58,88.74H65.29a.23.23,0,0,1,.2.34l-4.37,8.47a.23.23,0,0,0,.21.34h3.72a.24.24,0,0,1,.17.4l-13.06,14a.23.23,0,0,1-.39-.23l3.12-9.91a.23.23,0,0,0-.22-.3h-6.2a.23.23,0,0,1-.21-.34l6.11-12.59A.24.24,0,0,1,54.58,88.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.49,57.56a9.81,9.81,0,0,0-1.9-3.66,9.56,9.56,0,0,0-2.42-2.24,10.27,10.27,0,0,0-4.12-1.5c-.2,0-.45-.32-.54-.54a10,10,0,0,0-10.7-6.52,17.43,17.43,0,0,0-3.55.93,1.05,1.05,0,0,1-1.18-.41,11.86,11.86,0,0,0-4.6-3.91,13.08,13.08,0,0,0-2-.79c-.36-.1-.72-.2-1.1-.28a10.43,10.43,0,0,0-3-.18,12.07,12.07,0,0,0-1.2.14c-.58.09-1,.19-1.15.23l-.13.05a20.83,20.83,0,0,0-4.16,2,28.87,28.87,0,0,0-3.42,3.33l-.1,0A11.33,11.33,0,0,0,41,42.87,9.79,9.79,0,0,0,36.48,44a10.75,10.75,0,0,0-4.72,5,2.17,2.17,0,0,1-1.34,1,10.8,10.8,0,0,0-2.84,1A9.34,9.34,0,0,0,24,54.1c-.15.22-.29.42-.43.65a11.67,11.67,0,0,0-1.32,3.41,8.6,8.6,0,0,0,0,3.34,10,10,0,0,0,8.28,8.23,1.17,1.17,0,0,1,1,.84,10.23,10.23,0,0,0,14,5.43,1,1,0,0,1,1.25.32,12.48,12.48,0,0,0,20.18.1,1,1,0,0,1,1.25-.31A10.16,10.16,0,0,0,82.4,70.59a.84.84,0,0,1,.77-.57A10,10,0,0,0,91.49,57.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.12,37.62C60,39.15,48.63,40.3,36.24,45.79,26.79,50,23.43,53,23.43,42.68A18.73,18.73,0,0,1,42.16,24C52.5,24,60.5,29.32,60.12,37.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.58,88.74H65.29a.23.23,0,0,1,.2.34l-4.37,8.47a.23.23,0,0,0,.21.34h3.72a.24.24,0,0,1,.17.4l-13.06,14a.23.23,0,0,1-.39-.23l3.12-9.91a.23.23,0,0,0-.22-.3h-6.2a.23.23,0,0,1-.21-.34l6.11-12.59A.24.24,0,0,1,54.58,88.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.63,55.68c-.93,2.1-2,4.15-2.81,6.28a3,3,0,0,0,2.11,4,2.7,2.7,0,0,0,1.49,0,3,3,0,0,0,2-3.94C43.57,59.84,42.55,57.78,41.63,55.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.46,55.68c-.93,2.1-2,4.15-2.81,6.28a3,3,0,0,0,2.11,4,2.7,2.7,0,0,0,1.49,0,3,3,0,0,0,2-3.94C77.4,59.84,76.38,57.78,75.46,55.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58,52.62c-1.47,3.33-3.11,6.61-4.46,10-1.1,2.78.5,5.46,3.35,6.35a4.51,4.51,0,0,0,2.39-.06c2.77-1,4.23-3.52,3.15-6.27C61.11,59.24,59.48,56,58,52.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93,58.42a10,10,0,0,0-1.94-3.79,9.9,9.9,0,0,0-2.47-2.32,10.51,10.51,0,0,0-4.21-1.56c-.21,0-.47-.33-.56-.56A10.27,10.27,0,0,0,72.9,43.43a18.22,18.22,0,0,0-3.62,1A1.08,1.08,0,0,1,68.07,44a12.23,12.23,0,0,0-4.7-4,13.15,13.15,0,0,0-2.09-.82c-.37-.11-.74-.21-1.12-.29a10.24,10.24,0,0,0-3-.19,12.17,12.17,0,0,0-1.22.14,10.62,10.62,0,0,0-1.18.25l-.13,0a21.36,21.36,0,0,0-4.26,2.1,30.81,30.81,0,0,0-3.5,3.46l-.1,0a11.55,11.55,0,0,0-5.29-1.37,9.84,9.84,0,0,0-4.66,1.12A11.06,11.06,0,0,0,32,49.52a2.22,2.22,0,0,1-1.38,1.07,11.2,11.2,0,0,0-2.89,1,9.68,9.68,0,0,0-3.63,3.26c-.14.22-.3.44-.43.68A12.12,12.12,0,0,0,22.28,59a9.1,9.1,0,0,0,0,3.47A10.31,10.31,0,0,0,30.74,71a1.18,1.18,0,0,1,1,.87,10.25,10.25,0,0,0,8.48,6.63,10.11,10.11,0,0,0,5.85-1,1,1,0,0,1,1.28.32A12.66,12.66,0,0,0,68,78a1,1,0,0,1,1.28-.33,10.34,10.34,0,0,0,14.46-5.71.84.84,0,0,1,.79-.59A10.35,10.35,0,0,0,93,58.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.77,39A18.84,18.84,0,0,0,23.35,42a18.65,18.65,0,0,0,3.09,10.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 42.15,
    y1: 14.23,
    x2: 42.15,
    y2: 6.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 14.23,
    y1: 42.15,
    x2: 6.07,
    y2: 42.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.41,
    y1: 22.41,
    x2: 16.64,
    y2: 16.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 67.66,
    y1: 16.64,
    x2: 61.89,
    y2: 22.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 54.63,
    y1: 11.47,
    x2: 58.28,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 11.47,
    y1: 29.67,
    x2: 2.5,
    y2: 26.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 29.28,
    y1: 11.63,
    x2: 25.52,
    y2: 2.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 11.63,
    y1: 55.02,
    x2: 2.71,
    y2: 58.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 81.59,
    y1: 25.52,
    x2: 72.67,
    y2: 29.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderShowersDay);
export default __webpack_public_path__ + "static/media/thunder-showers-day.545dd2062c3e501db0f4c87a8857ad9d.svg";
export { ForwardRef as ReactComponent };